module.exports = __webpack_public_path__ + "static/media/recycle.cfcb27c9.svg";